'use client';

import {
  AudioWaveform,
  Briefcase,
  Command,
  GalleryVerticalEnd,
  Home,
  Info,
  Mail,
  Wrench,
} from 'lucide-react';

import { Sidebar, SidebarContent, SidebarRail } from '@/components/ui/sidebar';
import { NavMain } from '@/components/common/nav-main';
import React from 'react';

const data = {
  user: {
    name: 'John Doe',
    email: 'johndoe@example.com',
    avatar: '/avatars/shadcn.jpg',
  },
  teams: [
    {
      name: 'Acme Inc',
      logo: GalleryVerticalEnd,
      plan: 'Enterprise',
    },
    {
      name: 'Acme Corp.',
      logo: AudioWaveform,
      plan: 'Startup',
    },
    {
      name: 'Evil Corp.',
      logo: Command,
      plan: 'Free',
    },
  ],
  navMain: [
    {
      title: 'Home',
      collapsible: false,
      url: '/',
      icon: Home,
      items: [],
    },
    {
      title: 'Products',
      collapsible: false,
      url: '/products',
      icon: Home,
      items: [],
    },
    {
      title: 'Segments',
      collapsible: false,
      url: '/segments',
      icon: Home,
      items: [],
    },
    {
      title: 'Sectors',
      collapsible: false,
      url: '/sectors',
      icon: Home,
      items: [],
    },
    /*{
      title: 'Portfolio',
      url: '/portfolio',
      icon: LayoutGrid,
      isActive: false,
      items: [
        {
          title: 'Products',
          url: '/products',
        },
        {
          title: 'Segments',
          url: '/segments',
        },
        {
          title: 'Sectors',
          url: '/sectors',
        },
      ],
    },*/
    {
      title: 'Services',
      collapsible: false,
      url: '/services',
      icon: Wrench,
      items: [],
    },
    {
      title: 'About Us',
      collapsible: false,
      url: '/about',
      icon: Info,
      items: [],
    },
    {
      title: 'Careers',
      collapsible: false,
      url: '/careers',
      icon: Briefcase,
      items: [],
    },
    {
      title: 'Contact',
      collapsible: false,
      url: '/contact',
      icon: Mail,
      items: [],
    },
  ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar side={'right'} collapsible="icon" {...props}>
      {/* <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>*/}
      <SidebarContent>
        <NavMain items={data.navMain} />
        {/* <NavProjects projects={data.projects} />*/}
      </SidebarContent>
      {/*<SidebarFooter>
        <ThemeSwitch />
      </SidebarFooter>*/}
      <SidebarRail />
    </Sidebar>
  );
}
